import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function About() {
  return (
    <div className="App">
      <Header />
      <section className="max-w-5xl mx-auto px-5 lg:px-8 pt-14 pb-6">
        <div className="eyebrow">About us</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black mt-3 tracking-tight">A family business, built on print.</h1>
      </section>

      <section className="max-w-5xl mx-auto px-5 lg:px-8 pb-16 space-y-6 text-slate-700 text-lg leading-relaxed">
        <p>At Kwik Kopy Shellharbour, we believe great printing starts with great people.</p>
        <p>As a family-owned business, we're proud to help local businesses, entrepreneurs and organisations bring their ideas to life. From stickers and signage to marketing materials and everything in between, we're passionate about making print simple, accessible and professional.</p>
        <p>We understand that behind every order is a business trying to grow, a product ready to launch or an idea waiting to become reality. That's why we take pride in delivering quality products, providing friendly service and making the entire process as straightforward as possible.</p>
        <p>We've combined our passion for print with modern production technology to make ordering easier than ever. Through <Link to="/stickers" className="font-bold text-[#E4002B] hover:underline">Kwik Stickers</Link> and <Link to="/signs" className="font-bold text-[#003DA5] hover:underline">Kwik Signs</Link>, customers can now order custom stickers, corflute signs and foamboard online, with professional printing backed by our team at Kwik Kopy Shellharbour.</p>
        <p>Whether you're a small business ordering your first batch of stickers or an established company needing signage for your next project, we're here to help.</p>
        <p className="font-display text-xl font-bold text-slate-900 pt-2">We're a local business that cares about your business.</p>
        <p className="text-slate-500 italic">From our family to yours, thank you for choosing Kwik Kopy Shellharbour.</p>
      </section>

      <section className="max-w-5xl mx-auto px-5 lg:px-8 pb-24 grid sm:grid-cols-3 gap-4">
        <div className="sf-card p-6"><div className="eyebrow">Based in</div><div className="font-display font-black text-xl mt-1">Shellharbour, NSW</div></div>
        <div className="sf-card p-6"><div className="eyebrow">Owned by</div><div className="font-display font-black text-xl mt-1">A local family</div></div>
        <div className="sf-card p-6"><div className="eyebrow">Specialising in</div><div className="font-display font-black text-xl mt-1">Commercial print</div></div>
      </section>

      <Footer />
    </div>
  );
}
